import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { dateToString } from './ViewFridgeSoftware_utilities';
import PilotIcon from '../../../assets/PilotIcon';
import HazardIcon from '../../../assets/HazardIcon';

export const PilotsHeader = ({ multiplePilotFridges }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <span>Pilots</span>
      {multiplePilotFridges.size > 0 && (
        <div>
          <OverlayTrigger
            key="pilotHeaderHazard"
            placement="right"
            overlay={
              <Popover id="tooltip-pilotHeaderHazard">
                <div>
                  <h5 style={{ fontWeight: 'bold' }}>Warning</h5>
                  <span>
                    The following fridges have more than one pilot running on
                    it:
                  </span>
                  <br />
                  <br />
                  {Array.from(multiplePilotFridges).map((id) => {
                    return (
                      <span>
                        {id}
                        <br />
                      </span>
                    );
                  })}
                </div>
              </Popover>
            }
          >
            <div
              className="hazard"
              data-testid="hazard"
              style={{ display: 'flex' }}
            >
              <HazardIcon />
            </div>
          </OverlayTrigger>
        </div>
      )}
    </div>
  );
};

export const PilotsColumn = ({ rowData, pilotsData }) => {
  const fridge = rowData.fridgeName;

  let isPilot = false;
  const pilotData = [];
  let isFirst = true;

  pilotsData.map((pilot) => {
    pilot.fridgeIds.map((id) => {
      if (id === fridge) {
        isPilot = true;
        pilotData.push(pilot);
      }
    });
  });

  return (
    <div>
      {isPilot && (
        <div>
          <OverlayTrigger
            key={fridge}
            placement="right"
            overlay={
              <Popover id={`tooltip-${fridge}`}>
                {pilotData.map((pilot) => {
                  // eslint-disable-next-line no-return-assign
                  return (
                    <div>
                      {!isFirst ? <br /> : (isFirst = false)}
                      {pilot.displayName && (
                        <h4 style={{ fontWeight: 'bold' }}>
                          {pilot.displayName}
                        </h4>
                      )}
                      <hr style={{ marginTop: '10px', marginBottom: '10px' }} />
                      {pilot.startDate && pilot.endDate && (
                        <p>
                          Date: {dateToString(pilot.startDate)} to{' '}
                          {dateToString(pilot.endDate)}
                        </p>
                      )}
                      {pilot.stage && (
                        <p>
                          Stage:
                          {pilot.stage}
                        </p>
                      )}
                      {pilot.fridgeIds && (
                        <p>
                          Fridges:
                          {pilot.fridgeIds.length}
                        </p>
                      )}
                      {pilot.description && (
                        <p>
                          Description:
                          {pilot.description}
                        </p>
                      )}
                    </div>
                  );
                })}
              </Popover>
            }
          >
            <div
              className="pilot"
              data-testid="pilot"
              style={{ display: 'flex' }}
            >
              <PilotIcon color={pilotData[pilotData.length - 1].iconColor} />
            </div>
          </OverlayTrigger>
        </div>
      )}
    </div>
  );
};
